import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import $ from 'jquery'
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min.js'
import { AuthProvider } from './core/context/'
import Home from './Pages/Home'
import Transactionhistory from './Pages/Transactionhistory'
import Market from './Pages/Market'
import SignIn from './Pages/SignIn'
import SignUp from './Pages/SignUp'
import ForgotPassword from './Pages/ForgotPassword'
import ForgotPasswordOTP from './Pages/ForgotPasswordOTP'
import ResetPassword from './Pages/ResetPassword'
import Dashboard from './Pages/Dashboard'
import Faq from './Pages/Faq'

import CMS from './Pages/CMS'
// Bootstrap Bundle JS
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import OTCDesk from './Pages/OTCDesk.jsx'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import './assets/style.css'
import './assets/custom.css'
import './assets/styledev.css'
import './assets/modes.css'

import ProtectedRoute from './route.protected'

// dashboard profile
import GoogleAuthenticator from './PagesV2/Dashboard/Authenticator/GoogleAuthenticator.js'
import Spotnew from './Pages/exchange-trade/Spot'
// dashboard profile

import Comingsoon from './Pages/Comingsoon'
import Error404 from './Pages/Error404'
import LoginActivities from './PagesV2/Dashboard/LoginActivities/LoginActivities.js'
import WithdrawCrypto from './PagesV2/Portfolio/WithdrawCrypto.js'
import WithdrawFlatV2 from './PagesV2/Portfolio/WithdrawFlat.js'
import DepositCrypto from './PagesV2/Portfolio/DepositCrypto.js'
import DepositFlat from './PagesV2/Portfolio/DepositFlat.js'
import Contact from './PagesV2/Contact/Contact.js'
import ApiDocumentation from './Pages/ApiDocumentation/ApiDocumentation.js'
import MaintainceBreak from './Component/MaintainceBreak/MaintainceBreak.js'
import SignalsPro from './Pages/Signals.jsx'
import SpotChart from './Pages/exchange-trade/SpotChart.js'
import FuturesTradeWrap from './Pages/FuturesTradeWrap.js'
import FuturesTradeChart from './Pages/FuturesTradeChart.js'
import Blogs from './Pages/Blogs.js'
import BlogsDetails from './Pages/BlogsDetails.js'
import ScrollToTop from './Component/ScrollToTop/ScrollToTop.js'
import ConditionalStyles from './Component/ConditionalStyles/ConditionalStyles.js'
import ThankYou from './PagesV2/Contact/ThankYou.js'
import SpotUsdtWrap from './Pages/exchange-trade-usdt/Spot-usdt-wrap.js'
// import InstaTrade from './Pages/InstaTrade.js'
import SpotChartUsdt from './Pages/exchange-trade-usdt/SpotChart-usdt.js'
import PremiumDashboard from './PagesV2/PremiumDashboard/index.js'
import DepositFlatdisable from './PagesV2/Portfolio/DepositFlatdisable.js'
import DepositCryptoDisable from './PagesV2/Portfolio/DepositCryptoDisable.js'
import Training from './PagesV2/Training/Training.js'
import Career from './Pages/Career.jsx'
import SubBroker from './Pages/SubBroker.jsx'
import Learn from './Pages/Learn.jsx'
import Earn from './Pages/Earn.jsx'
import VIPTrading from './Pages/VIPTrading.jsx'
import Partnership from './Pages/Partnership.jsx'
import AboutUs from './Pages/About.js'
import CookieConsent from './Component/CookieConsent/CookieConsent.jsx'

function App() {
  const mode = localStorage.getItem('mode')
    ? localStorage.getItem('mode')
    : 'light-new'

  const [theme, setTheme] = useState(mode)
  const [isBreak, setIsBreak] = useState(false)
  const routes = [
    // common§±
    {
      path: '/',
      name: 'home',
      component: <Home setTheme={setTheme} theme={theme} />,
    },
    { path: '/faq', component: <Faq setTheme={setTheme} theme={theme} /> },
    {
      path: '/markets',
      component: <Market setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/signal',
      component: <SignalsPro setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/futures/trade/:pairName',
      component: <FuturesTradeWrap setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/futures-chart/:pairName',
      component: <FuturesTradeChart setTheme={setTheme} theme={theme} />,
    },
    // {
    //   path: '/Insta-Trade',
    //   authChk: 'afterLoginOnly',
    //   component: <InstaTrade setTheme={setTheme} theme={theme} />,
    // },
    {
      path: '/about',
      component: <AboutUs setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/otc-desk',
      component: <OTCDesk setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/vip-trading',
      component: <VIPTrading setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/partnership',
      component: <Partnership setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/sub-broker',
      component: <SubBroker setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/learn-crypto',
      component: <Learn setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/earn',
      component: <Earn setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/contact-support',
      component: <CMS setTheme={setTheme} theme={theme} identify='contactus' />,
    },
    {
      path: '/thank_you',
      component: <ThankYou setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/blockchain-and-cryptocurrency-training',
      component: <Training setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/career',
      component: <Career />,
    },
    {
      path: '/help-center',
      component: <Contact setTheme={setTheme} theme={theme} />,
    },
    // { path: '/terms', component: <CMS setTheme={setTheme} theme={theme} identify="terms" /> },
    // { path: '/privacy-policy', component: <CMS setTheme={setTheme} theme={theme} identify="privacy" /> },
    {
      path: '/api-docs',
      component: <ApiDocumentation setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/register',
      authChk: 'beforeLoginOnly',
      component: <SignUp setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/login',
      authChk: 'beforeLoginOnly',
      component: <SignIn setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/ForgotPassword',
      authChk: 'beforeLoginOnly',
      component: <ForgotPassword setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/ForgotPasswordOTP',
      authChk: 'beforeLoginOnly',
      component: <ForgotPasswordOTP setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/ResetPassword',
      authChk: 'beforeLoginOnly',
      component: <ResetPassword setTheme={setTheme} theme={theme} />,
    },

    // user
    {
      path: '/my/wallet/history',
      authChk: 'afterLoginOnly',
      component: <Transactionhistory setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/my/wallet/history/:tabName',
      authChk: 'afterLoginOnly',
      component: <Transactionhistory setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/my/:tabName',
      authChk: 'afterLoginOnly',
      component: <Dashboard setTheme={setTheme} theme={theme} />,
    },

    {
      path: '/deposit/crypto/:currencyId',
      authChk: 'afterLoginOnly',
      component: <DepositCryptoDisable setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/deposit/cryptodisabledlatest/:currencyId',
      authChk: 'afterLoginOnly',
      component: <DepositCrypto setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/deposit/fiat/:currencyId',
      authChk: 'afterLoginOnly',
      component: <DepositFlatdisable setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/depositdisabledlatest/fiat/:currencyId',
      authChk: 'afterLoginOnly',
      component: <DepositFlat setTheme={setTheme} theme={theme} />,
    },

    {
      path: '/deposit',
      authChk: 'afterLoginOnly',
      component: <DepositCrypto setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/withdraw/fiat/:currencyId',
      authChk: 'afterLoginOnly',
      component: <WithdrawFlatV2 setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/withdraw/crypto/:currencyId',
      authChk: 'afterLoginOnly',
      component: <WithdrawCrypto setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/withdraw',
      authChk: 'afterLoginOnly',
      component: <WithdrawCrypto setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/google-authenticator',
      authChk: 'afterLoginOnly',
      component: <GoogleAuthenticator setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/device-management',
      component: <LoginActivities setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/blogs',
      component: <Blogs setTheme={setTheme} theme={theme} identify='dyn' />,
    },
    {
      path: '/blog/:link',
      component: (
        <BlogsDetails setTheme={setTheme} theme={theme} identify='dyn' />
      ),
    },

    {
      path: '/spot/:pairName',
      component: <Spotnew setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/spot/pro/:pairName',
      component: <Spotnew setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/spot-usdt/:pairName',
      component: <SpotUsdtWrap setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/spot-usdt-chart/:pairName',
      component: <SpotChartUsdt setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/spot-chart/:pairName',
      component: <SpotChart setTheme={setTheme} theme={theme} />,
    },

    {
      path: '/premium',
      authChk: 'afterLoginOnly',
      component: <PremiumDashboard setTheme={setTheme} theme={theme} />,
    },

    {
      path: '/comingsoon',
      component: <Comingsoon setTheme={setTheme} theme={theme} />,
    },
    {
      path: '/error404',
      component: <Error404 setTheme={setTheme} theme={theme} />,
    },
    {
      path: "/:dynCMS/:dynCMS2?",
      component: <CMS setTheme={setTheme} theme={theme} identify='dyn' forWhat="exchange" />,
    },
    // { path: '*', component: <Error404 setTheme = {setTheme} theme={theme} />},
  ]

  useEffect(() => {
    if ($('#themesection-body').hasClass('light-new')) {
      $('body').addClass('light-new')
      $('body').removeClass('dark-new')
    } else {
      $('body').addClass('dark-new')
      $('body').removeClass('light-new')
    }

    if (window.location.pathname === '/') {
      setTheme('light-new')
      $('#classy-navbar-mobile').css('background-color', 'transparent')
      $('.theme-mode-dropdown').hide()
    }
  }, [theme])
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <AuthProvider>
      <div className={theme} id='themesection-body'>
        <ToastContainer />
        <CookieConsent />
        <Router>
          <ScrollToTop />
          <ConditionalStyles />
          {isBreak ? (
            <MaintainceBreak />
          ) : (
            <Routes>
              {routes.map((data, index) => {
                return (
                  <Route
                    element={
                      <ProtectedRoute
                        authChk={data.authChk ? data.authChk : ''}
                      />
                    }
                  >
                    <Route
                      onUpdate={() => window.scrollTo(0, 0)}
                      exact={true}
                      path={data.path}
                      element={data.component}
                      key={index}
                    />
                  </Route>
                )
              })}
            </Routes>
          )}
        </Router>
      </div>
    </AuthProvider>
  )
}

export default App
